import React from 'react';
import { Box, Tooltip, Typography } from '@saviynt/design-system';

import { CF_PRI_MED } from '../../../constants';
import { useInvertedLocalize } from '../../../hooks';

import './AuditLogColumnFilterBodyNote.css';

/**
 * AuditLogColumnFilterBodyNote Component
 *
 * Displays an informational message about visible attributes and provides
 * a tooltip link to the details panel.
 */
function AuditLogColumnFilterBodyNote() {
  const l = useInvertedLocalize();

  return (
    <Box className='AuditLogColumnFilter-bodyNote-frame'>
      <div className='AuditLogColumnFilter-bodyNote'>
        {l(
          'The number of visible attributes depends on the size of your browser. Any attributes not shown are visible in the' +
            ' '
        )}
        <span className='AuditLogColumnFilter-detailsPanelLink'>
          <div
            className='AuditLogColumnFilter-detailsPanelLink-text'
            color={CF_PRI_MED}>
            <Tooltip
              trigger={
                <Typography kind='body3' color={CF_PRI_MED}>
                  {l('details panel')}
                </Typography>
              }
              text={l('Tap anywhere on the row to open the details panel.')}
              placement='bottom-start'
            />
          </div>
        </span>
      </div>
    </Box>
  );
}

export default AuditLogColumnFilterBodyNote;
